import React, { useContext, useState } from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    Flex,
    Icon,
    Heading,
    Stack,
    Text,
    Divider
} from '@chakra-ui/react';

import { LandClass } from '../../../core/land';
import { ProfileContext } from '../../../core/contexts';
import { GiShare } from 'react-icons/gi';

export default function LandCard(props: {
    data: LandClass;
}): React.ReactElement {
    const { t } = useTranslation();
    const { user } = useContext(ProfileContext);

    const [land, setland] = useState<LandClass>(props.data);

    return (
        <Box
            w={'full'}
            bg='white'
            boxShadow='base'
            _hover={{ boxShadow: 'lg' }}
            rounded={'md'}
            p={2}
            overflow={'hidden'}
        >
            <Box
                h={'210px'}
                bg={'gray.100'}
                mt={-2}
                mx={-2}
                mb={4}
                pos={'relative'}
                bgImage={`url('${land.getImageFav()}')`}
                bgPosition='center'
                bgRepeat='no-repeat'
                bgSize='cover'
            >
                <Flex
                    justify={'space-around'}
                    direction='column'
                    align={'flex-end'}
                    p='4'
                    pos={'relative'}
                    h='100%'
                    _before={{
                        position: 'absolute',
                        content: `''`,
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                            'linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%)'
                    }}
                >
                    {land
                        .countAnimalsBySpecie()
                        .map((animal: Record<string, any>, index: number) => (
                            <Flex
                                key={index}
                                direction='row'
                                align={'center'}
                                pos='relative'
                            >
                                <Text
                                    fontSize='xl'
                                    fontWeight='bold'
                                    color='white'
                                >
                                    {animal.amount}
                                </Text>
                                <Icon
                                    as={animal.getIcon()}
                                    color='white'
                                    w='8'
                                    h='8'
                                />
                            </Flex>
                        ))}
                    {land.editors.length + land.readers.length > 0 && (
                        <Flex direction='row' align={'center'} pos='relative'>
                            <Text fontSize='xl' fontWeight='bold' color='white'>
                                {land.editors.length + land.readers.length}
                            </Text>
                            <Icon as={GiShare} w='8' h='8' color='white' />
                        </Flex>
                    )}
                </Flex>
            </Box>
            <Stack px='2'>
                <Heading color='green.700' fontSize={'2xl'} noOfLines={1}>
                    {land.name}
                </Heading>
                {land.owner !== user.id && (
                    <Text
                        minH='12px'
                        fontSize='xs'
                        style={{ marginTop: '0rem' }}
                        fontWeight='bold'
                        noOfLines={1}
                    >
                        {t('land.owner')}: {land.ownerUser.name}
                    </Text>
                )}
                <Divider style={{ marginTop: '0rem' }} />
                {land.description?.length ? (
                    <Text noOfLines={2}> {land.description}</Text>
                ) : (
                    <Text as='i'>{t('land.noDescription')}</Text>
                )}
            </Stack>
            <Stack mt='4' mb='2' align={'center'}>
                <RouteLink to={t('routes.lands') + `/${land.id}`}>
                    <Button
                        colorScheme='green'
                        bg='green.600'
                        display={'block'}
                        m='auto'
                    >
                        {t('global.seeDetails')}
                    </Button>
                </RouteLink>
            </Stack>
        </Box>
    );
}
